<template>
  <div id="app">
    <div class="overview">
      <div 
      id="start"
      v-bind:class="{'visible': showStartOverlay}"
      v-if="!hideStartOverlay"
      v-on:click="toggleStartOverlay()"
      >
        <div class="start-inner">
          <div class="images">
            <img src="./assets/start-mini-1.jpg" alt="">
            <img src="./assets/start-mini-4.jpg" alt="">
            <img src="./assets/start-mini-3.jpg" alt="">
            <img src="./assets/start-mini-2.jpg" alt="">
          </div>
        </div>
      </div>
      <img id="logo" src="./assets/resinit-logo.svg" alt="">
      <div 
      class="roof"
      v-bind:class="{'on': roofOn}"
      v-on:click="toggleRoof()"
      ></div>
      
      <div class="overview-inner" v-bind:class="{'pallet-open' : currentPallet != false}">
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'produktion-svarv'}" 
        view="produktion-svarv" 
        video="true"
        top="9" 
        left="33"
        name="Turning"
        :controlSettings="{ xAxis: {min: 60, max:180}, yAxis: {min: 70, max: 90}, xStart: 250 }"
        />
        
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'montering-1'}" 
        view="montering-1" 
        video="true"
        top="32" 
        left="69" 
        name="Assembly"
        :controlSettings="{ xAxis: {min: 120, max:10}, yAxis: {min: 70, max: 110}, xStart: 45 }"
        />
        
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'montering-2'}" 
        view="montering-2" 
        video="true"
        top="25" 
        left="67" 
        name="Assembly"
        :controlSettings="{ xAxis: {min: 60, max: 100}, yAxis: {min: 70, max: 110}, xStart: 0 }"
        />
        
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'entre'}" 
        view="entre" 
        top="15" 
        left="15" 
        name="Lobby"
        video="true"
        :controlSettings="{ xAxis: {min: 0, max:360}, yAxis: {min: 70, max: 110}, xStart: 93 }"
        />
        
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'foaje'}" 
        view="foaje" 
        top="6" 
        left="24" 
        name="Foyer"
        :controlSettings="{ xAxis: {min: 60, max:140}, yAxis: {min: 70, max: 110}, xStart: 45 }"
        />
        
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'kpi-mote'}" 
        view="kpi-mote" 
        top="10" 
        left="27" 
        name="KPI meeting"
        video="true"
        :panorama=false
        :controlSettings="{ xAxis: {min: 60, max:140}, yAxis: {min: 70, max: 110}, xStart: 45 }"
        />
        
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'lager-1'}" 
        view="lager-1" 
        top="25" 
        left="31" 
        name="Storage"
        video="true"
        :controlSettings="{ xAxis: {min: 20, max:145}, yAxis: {min: 70, max: 110}, xStart: 135 }"
        />
        
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'lager-2'}" 
        view="lager-2" 
        top="22" 
        left="46" 
        name="Storage"
        video="true"
        :controlSettings="{ xAxis: {min: 0, max:360}, yAxis: {min: 70, max: 110}, xStart: 197 }"
        />
        
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'produktion-pos-1'}" 
        view="produktion-pos-1" 
        top="8" 
        left="38" 
        name="Production"
        video="true"
        :controlSettings="{ xAxis: {min: 130, max:70}, yAxis: {min: 90, max: 90}, xStart: 35 }"
        />
        
        <!--
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'produktion-pos-2'}" 
        view="produktion-pos-2" 
        top="17" 
        left="52" 
        name="Production"
        :controlSettings="{ xAxis: {min: 0, max:360}, yAxis: {min: 70, max: 110}, xStart: 0 }"
        />
        -->
        
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'multiop'}" 
        view="multiop" 
        top="13" 
        left="54" 
        name="Multiop machines"
        video="true"
        :controlSettings="{ xAxis: {min: 160, max:350}, yAxis: {min: 70, max: 90}, xStart: 0 }"
        />
        
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'matsal'}" 
        view="matsal" 
        top="3" 
        left="31" 
        name="Canteen"
        :controlSettings="{ xAxis: {min: 0, max:360}, yAxis: {min: 70, max: 90}, xStart: 0 }"
        />
        
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'matrum'}" 
        view="matrum" 
        top="21" 
        left="53" 
        name="Measuring"
        video="true"
        :controlSettings="{ xAxis: {min: 1, max:70}, yAxis: {min: 90, max: 90}, xStart: 20 }"
        />
        
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'limrum'}" 
        view="limrum" 
        top="22" 
        left="71" 
        name="Glueing"
        :controlSettings="{ xAxis: {min: 420, max:160}, yAxis: {min: 70, max: 90}, xStart: 310 }"
        />
        
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'renare-rum'}" 
        view="renare-rum" 
        top="25" 
        left="76" 
        name="Cleaner room"
        video="true"
        :controlSettings="{ xAxis: {min: 110, max:440}, yAxis: {min: 70, max: 90}, xStart: 260 }"
        />
        
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'konferensrum-1'}" 
        view="konferensrum-1" 
        top="19" 
        left="15"
        name="Conference room"
        :controlSettings="{ xAxis: {min: 80, max:460}, yAxis: {min: 90, max: 90}, xStart: 85 }" 
        />
        
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'konferensrum-2'}" 
        view="konferensrum-2" 
        top="2.5"
        left="39" 
        name="Conference room"
        :controlSettings="{ xAxis: {min: 0, max:360}, yAxis: {min: 90, max: 90}, xStart: 0 }"
        />
         
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'konventionella-maskiner'}" 
        view="konventionella-maskiner" 
        top="25" 
        left="61" 
        name="Conventional machines"
        :controlSettings="{ xAxis: {min: 120, max:40}, yAxis: {min: 90, max: 90}, xStart: 100 }"
        />
        
        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'utomhus-entre'}" 
        view="utomhus-entre" 
        video="true"
        top="26" 
        left="20" 
        name="Entrance"
        :controlSettings="{ xAxis: {min: 170, max: 400}, yAxis: {min: 70, max: 110}, xStart: 180 }"
        />

        <StreetViewTarget 
        v-if="!roofOn && showStreetViewTargets" 
        v-bind:class="{'current' : currentPallet == 'utomhus-framsida'}" 
        view="utomhus-framsida" 
        top="4" 
        left="12" 
        name="Front view"
        :controlSettings="{ xAxis: {min: 0, max: 360}, yAxis: {min: 70, max: 110}, xStart: 310 }"
        />
        
        <Viewer 
        v-if="currentView != false" 
        :view="currentView" 
        :controlSettings="controlSettings"
        />
      </div>
    </div>
    <div class="controls" 
    v-bind:class="{'visible': hideStartOverlay}"
    >
      <button v-on:click="showStreetViewTargets = !showStreetViewTargets">
        <span v-if="!showStreetViewTargets">Visa</span><span v-if="showStreetViewTargets">Dölj</span> punkter
      </button>  
      <button v-on:click="toggleStartOverlay">
        Start
      </button>  
      <button v-on:click="roofOn = !roofOn">
        <span v-if="!roofOn">Lägg på</span><span v-if="roofOn">Ta av</span> tak
      </button>  
    </div>
    <div class="iframe-container" v-if="iframesrc != ''">
      <button 
      class="closes-iframe"
      v-on:click="closeIframe"
      >Stäng</button>
      <iframe v-bind:src="iframesrc" class="iframe"></iframe>
    </div>
    <div 
    class="video-player"
    v-if="videoFile !== false"
    >
      <button 
      class="close-player"
      v-on:click="closeVideoPlayer"
      >Stäng</button>
      <video 
      id="video"
      v-if="videoFile !== false" 
      v-bind:src="videoFile" autoplay muted loop
      v-on:click="pauseVideo"
      ></video>
  </div>
  </div>
</template>

<script>
import StreetViewTarget from './components/StreetViewTarget.vue'
import Viewer from './components/Viewer.vue'

export default {
  name: 'App',
  components: {
    StreetViewTarget,
    Viewer
  },
  data: function(){
    return {
      iframesrc: '',
      roofOn: false,
      showStreetViewTargets: false,
      hideStartOverlay: false,
      currentView: false,
      currentPallet: false,
      videoFile: false,
      showStartOverlay: true,
      controlSettings: {
        xAxis: {
          min: 0,
          max: 360
        },
        yAxis: {
          min: 70,
          max: 110
        },
        xStart: 0
      }
    }
  },
  mounted: function(){
  },
  methods: {
    setIframeSrc(url){
      this.iframesrc = url;
    },
    closeIframe(){
      this.iframesrc = '';
    },
    toggleRoof(){
      this.roofOn = !this.roofOn;
      this.currentView = false;
      this.currentPallet = false;
    },
    toggleStartOverlay(){
      let self = this;

      if( !self.showStartOverlay ){
        self.hideStartOverlay = !self.hideStartOverlay;
      } else {
        setTimeout(function(){
          self.hideStartOverlay = !self.hideStartOverlay;
        }, 800);
      }
      this.showStartOverlay = !this.showStartOverlay;
      
    },
    pauseVideo(){
      if( document.getElementById("video").paused ){
        document.getElementById('video').play();
      } else {
        document.getElementById('video').pause();
      }
    },
    setViewerView(view){
      this.currentView = view;
    },
    setVideoFile(view){
      this.videoFile = require('./assets/video/' + view + '.mp4');
      console.log(this.videoFile);
    },
    closeVideoPlayer(){
      this.videoFile = false;
    }
  }
}
</script>

<style>
body {
  padding: 0;
  margin: 0;
  overflow: hidden;
}

#app {
  font-family: "Lato Regular", Lato, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  background: #000;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

#start {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 100vh;
  z-index: 500;
}

#start.visible {
  transform: scale(1);
  opacity: 1;
}

#start.visible .start-inner {
  transform: scale(1);
  opacity: 1;
}

#start .start-inner {
  background: url('./assets/start.jpg') top center no-repeat;
  background-size: cover;
  height: 100vh;
  width: 100vw;
  max-height: 56.25vw;
  position: relative;
  transition: all 0.81s;
  opacity: 0;
  transform: scale(1.5);
  opacity: 0;
  transition: all 0.81s;

}

#start.visible .images img {
  transform: translateY(0vh);
  opacity: 1;
}

#start .images {
  position: absolute;
  bottom: 5%;
  display: flex;
  justify-content: space-around;
}
#start .images img {
  width: 20%;
  transform: translateY(25vh);
  filter: grayscale(.35);
  transition: all 0.81s;
  opacity: 0;
}

#logo {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 15vw;
}

.iframe-container {
  top: 0vh;
  left: 0vw;
  width: 100vw;
  height: 100vh;
  position: absolute;
  background: rgba(0,0,0,0.5);
}

.closes-iframe {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 100;
}

.iframe {
  top: 5vh;
  left: 5vw;
  width: 90vw;
  height: 90vh;
  position: absolute;
  background: transparent;
  border: 0;
}

.iframe[src=""] {
  display: none;
}

.overview {
  width: 100vw;
  background-color: #000;
  background-size: cover;
  position: absolute;
  line-height: 0;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 100vh;
  max-height: 56.25vw;
  /* padding-bottom: 56.25vw; */
  background-image: url('./assets/overview.png');
}

.overview .overview-inner {
  width: 100%;
  height: 100%;
  position: relative;
}

.overview .overview-inner.pallet-open .streetview-target {
  display: none
}
.overview .overview-inner.pallet-open .streetview-target.current {
  display: block;
}

.overview .roof {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 1px;
  height: 100vh;
  max-height: 56.25vw;
  background: url('./assets/roof.png');
  background-size: 100%;
  background-position: center center;
  width: 100%;
  height: 100%;
  transform: translateY(-300vh);
  transition: transform 0.85s;
  z-index: 400;
}

.overview .roof.on {
  transform: translateY(0vh);
}

.controls {
  position: absolute;
  top: 5vw;
  right: 10px;
  max-width: 220px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.controls.visible button {
  transform: translateY(0);
}

.controls button {
  background-color: #196390;
  color: #fff;
  border: 0px;
  border-radius: 0px;
  font-size: 13px;
  padding: 0.5em 1em;
  text-transform: uppercase;
  z-index: 50;
  margin-left: 1em;
  margin-bottom: 1em;
  transition: all 0.25s;
  transform: translateX(200%);
}
.controls button span {
}
.controls button:focus {
  outline: none;
}

.video-player {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  padding: 10px;
  z-index: 250;
  background: rgba(0,0,0,0.85);
  display: flex;
  justify-content: center;
  align-content: center;
}

.video-player video {
  max-width: 100%;
}

button.close-player {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 100;
  width: 5vw;
  height: 5vw;
  min-width: 32px;
  min-height: 32px;
  max-width: 48px;
  max-height: 48px;
  border: 0px;
  border-radius: 50%;
  font-size: 0;
  background: url('./assets/close.png') center center no-repeat;
  background-color: #196390;
  background-size: 80% 80%;
  transition: all 0.25s;
  z-index: 210;
}

button.close-player:focus {
  outline: none;
  transform: scale(0.7);
}

</style>
